import Shipment from '../../../types/api/shipment'
import {
    DesignerTasksTableRow,
    NO_SHIPMENT_HEADER_ROW_TYPE,
    NoShipmentHeaderRow,
    SHIPMENT_HEADER_ROW_TYPE,
    ShipmentHeaderRow,
} from '../types/table-row'

export const getRowKey = (record: DesignerTasksTableRow) => {
    if (isShipmentHeader(record)) return `header-${record.documentId}`
    if (isNoShipmentHeader(record)) return 'header-no-shipment'
    return String(record.id)
}

export function createShipmentHeaderRow(shipment: Shipment): ShipmentHeaderRow {
    return { ...shipment, __rowType: SHIPMENT_HEADER_ROW_TYPE }
}

export function createNoShipmentHeaderRow(): NoShipmentHeaderRow {
    return { __rowType: NO_SHIPMENT_HEADER_ROW_TYPE }
}

export function isShipmentHeader(record: DesignerTasksTableRow): record is ShipmentHeaderRow {
    return '__rowType' in record && record.__rowType === SHIPMENT_HEADER_ROW_TYPE
}

export function isNoShipmentHeader(record: DesignerTasksTableRow): record is NoShipmentHeaderRow {
    return '__rowType' in record && record.__rowType === NO_SHIPMENT_HEADER_ROW_TYPE
}

export function isGroupHeader(
    record: DesignerTasksTableRow
): record is ShipmentHeaderRow | NoShipmentHeaderRow {
    return isShipmentHeader(record) || isNoShipmentHeader(record)
}
